const cell = (v) => {
  if (v === null || v === undefined) return "";
  if (typeof v === "number") return String(v);
  let s = String(v);
  if (/^[=+\-@\t\r]/.test(s)) s = `'${s}`;
  return /[",\n\r]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
};

export function downloadCsv(filename, header, rows) {
  const text = [header, ...rows].map((r) => r.map(cell).join(",")).join("\r\n");
  const blob = new Blob(["\uFEFF" + text], { type: "text/csv;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}

const ymd = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
export const todayYmd = () => ymd(new Date());

const LOAD_HEADER = ["Load #", "Broker ref #", "Broker", "Rate (USD)", "Accessorials (USD)", "Total billable (USD)", "Pickup", "Delivery", "Pickup date", "Delivery date", "Driver", "Status", "Created date", "Invoiced", "Invoice status"];

export function exportLoadsCsv(loads, filtered) {
  const rows = loads.map((l) => [
    l.carrier_number || "", l.load_number, l.broker_name, Number(l.rate), Number(l.accessorials_total || 0), Number(l.billable_total ?? l.rate), l.pickup_location, l.delivery_location,
    l.pickup_date || "", l.delivery_date || "", l.driver_name || "Unassigned", l.status,
    l.created_at ? ymd(new Date(l.created_at)) : "", l.invoice_id ? "Yes" : "No", l.invoice_status || "",
  ]);
  downloadCsv(`fleet-sheet-loads${filtered ? "-filtered" : ""}-${todayYmd()}.csv`, LOAD_HEADER, rows);
}
